import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getClientUsers,
  inviteClientUser,
  removeClientUser,
} from "apps/project-iq/api";
import { IClientUser } from "apps/project-iq/models/IClientUser";

export interface IInviteClientUserParams {
  email: string;
  displayName?: string;
  message?: string;
}

const clientUsersQueryKey = (workspaceId: string) => [
  "client-users",
  workspaceId,
];

export const useClientUsers = (workspaceId: string) =>
  useQuery<IClientUser[], Error>({
    queryKey: clientUsersQueryKey(workspaceId),
    queryFn: () => getClientUsers(workspaceId),
    enabled: !!workspaceId,
  });

export const useInviteClientUser = (workspaceId: string) => {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, IInviteClientUserParams>(
    (params: IInviteClientUserParams) =>
      inviteClientUser({
        workspaceId,
        email: params.email,
        displayName: params.displayName,
        message: params.message,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(clientUsersQueryKey(workspaceId));
      },
    },
  );
};

export const useRemoveClientUser = (workspaceId: string) => {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, string>(
    (clientUserId: string) => removeClientUser({ workspaceId, clientUserId }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(clientUsersQueryKey(workspaceId));
      },
    },
  );
};
